// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KI1g","newExpiryDate":"styles_newExpiryDate__uwWDU","footer":"styles_footer__1bKGO"};